import { useBoundStore } from 'useStore';
import FilterChip from './utils/FilterChip';
import { Stack } from '@mui/material';

export default function CategoryPathFiltersChip() {
	const selectedCategory = useBoundStore(
		(state) => state.productMasterSelectedCategory
	);
	const clearProductMasterSelectedCategory = useBoundStore(
		(state) => state.clearProductMasterSelectedCategory
	);

	if (selectedCategory === null) return null;

	return (
		<Stack direction="row" flexWrap="wrap" gap={1}>
			<FilterChip
				filterName="Category"
				title={selectedCategory}
				onDelete={() => clearProductMasterSelectedCategory()}
			/>
		</Stack>
	);
}
